import ApexLineChart from 'Components/charts/ApexLine'
import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap';

const Indicator = ({ indicatorName, logListInfo, logListInfoDt, logListRiverInfo, logListRiverInfoDt, logListSpringInfo, logListSpringInfoDt, logListIceRIverInfo, logListIceRIverInfoDt }: any) => {


  const [minListValue, setMinListValue] = useState<any>(0)
  const [maxListValue, setMaxListValue] = useState<any>(0)
  const [limitData, setLimitData] = useState<number[]>([])

  const [saleMinValue, setSaleMinValue] = useState<any>(0)
  const [saleMaxValue, setSaleMaxValue] = useState<any>(0)
  const [saleLimitData, setSalesLimitData] = useState<number[]>([])


  useEffect(() => {
    setMinMaxvalue(logListInfo, setMinListValue, setMaxListValue, setLimitData);
    console.log('logListRiverInfoDt', logListRiverInfoDt)
  }, [logListInfo, logListInfoDt, logListRiverInfo, logListRiverInfoDt]);


  function setMinMaxvalue(dashData, setMin, setMax, setLimit) {
    setLimit((prevLimitData = []) => {
      const updatedLimitData = [...prevLimitData, ...dashData];
      const numericData = updatedLimitData.map((item) => {
        if (item.data.length > 1) {
          const minVal = Math.min(...item.data);
          const maxVal = Math.max(...item.data);
          setMin(minVal);
          setMax(maxVal);
        } else if (item.data.length === 1) {
          setMax(item.data[0].data);
        }
      });
      return updatedLimitData
    });
  }

  useEffect(() => {
  }, [minListValue, maxListValue]);

  useEffect(() => {
  }, [saleMinValue, saleMaxValue]);

  return (

    <React.Fragment>

      <Col lg={6} md={12}>
        <Card>
          <CardBody>
            <ApexLineChart indicatorName={indicatorName} result={logListInfo} categories={logListInfoDt} minValue={minListValue} maxValue={maxListValue} title={'Нуур тойром'} dataColors='["--bs-primary", "--bs-success"]' />
          </CardBody>
        </Card>
      </Col>
      <Col lg={6} md={12}>
        <Card>
          <CardBody>
            <ApexLineChart indicatorName={indicatorName} result={logListRiverInfo} categories={logListRiverInfoDt} title={'Гол мөрөн'} dataColors='["--bs-primary", "--bs-success"]' />

          </CardBody>
        </Card>
      </Col>
      <Col lg={6} md={12}>
        <Card>
          <CardBody>

            <ApexLineChart indicatorName={indicatorName} result={logListSpringInfo} categories={logListSpringInfoDt} title={'Булаг шанд'} dataColors='["--bs-primary", "--bs-success"]' />
          </CardBody>
        </Card>
      </Col>
      <Col lg={6} md={12}>
        <Card>
          <CardBody>
            {logListIceRIverInfo && logListIceRIverInfo.length > 0 && logListIceRIverInfoDt ? (
              <ApexLineChart
                indicatorName={indicatorName}
                result={logListIceRIverInfo}
                categories={logListIceRIverInfoDt}
                minValue={minListValue}
                maxValue={maxListValue}
                title={'Мөстлөг, мөсөн гол'}
                dataColors='["--bs-primary", "--bs-success"]'
              />
            ) : null}
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

export default Indicator;